import React, { Component } from 'react';
import axios from "axios";

class SearchBar extends Component {

    state = {results: [], loading: false, search: null};

    _search = (text) => {
        if(text.length > 0) {
            this.setState({loading: true, search: text});
            axios.get(window.Laravel.apiUrl+`/map-locations`, {
                params: {
                    search: text,
                    limit: 5,
                    lang: $('html').attr('lang')
                }
            })
                .then(res => {
                    this.setState({
                        results: res.data.locations,
                        loading: false
                    });
                })
                .catch(() => this.setState({loading: false}));
        }
    };


    render() {
        return (
            <div className="form-group">
                <div className="input-group">
                    <input
                        autoComplete="off"
                        id="search_input"
                        type="text"
                        className="form-control lang input-pill border-accent"
                        placeholder={__("Search")}
                        onKeyUp={(event) => {
                            this._search(event.currentTarget.value);
                        }}
                    />
                    <div className="input-group-append">
                        {
                            this.state.loading ?
                                <button className="btn btn-outline-accent btn-pill">
                                    <i className="fa fa-spinner fa-spin"></i>
                                </button>
                                :
                                this.state.search ?
                                    <button className="btn btn-outline-accent btn-pill"
                                            onClick={() => {
                                                this.setState({search: null, results: []});
                                                document.getElementById('search_input').value = '';
                                            }}>
                                        <i className="fa fa-times"></i>
                                    </button>
                                    :
                                    <button className="btn btn-outline-accent btn-pill" onClick={() => this._search(this.state.search)}>
                                        <i className="fa fa-search"></i>
                                    </button>
                        }
                    </div>
                </div>
                {
                    this.state.results.map((location, index) => {
                        return (
                            <div
                                className="search-result"
                                key={index}
                                style={{top: 65 + (index * 35)}}
                                onClick={() => {
                                    this.props.findSelection(location, 18);
                                    this.setState({results: []})
                                }}
                            >
                                {location.title}
                            </div>
                        )
                    })
                }
            </div>

        )
    }
}

export default SearchBar;
